import React, { Component } from "react";
import { Link } from "react-router-dom";

class TravelRequestDetail extends Component {
  renderStatus(status) {
    const map = {
      Draft: ["#F1F5F9", "#475569"],
      "Pending Approval": ["#FFF7E6", "#B76E00"],
      Approved: ["#ECFDF3", "#027A48"],
      Rejected: ["#FEECEC", "#B42318"],
    };

    const [bg, color] = map[status] || map.Draft;

    return (
      <span style={{ background: bg, color, padding: "6px 10px", borderRadius: 20, fontSize: 12, fontWeight: 900 }}>
        {status}
      </span>
    );
  }

  renderInfo(label, value) {
    return (
      <div style={{ marginBottom: 12 }}>
        <div style={infoLabel}>{label}</div>
        <div style={infoValue}>{value || "-"}</div>
      </div>
    );
  }

  renderSection(title, children) {
    return (
      <div style={card}>
        <h4 style={sectionTitle}>{title}</h4>
        {children}
      </div>
    );
  }

  render() {
    const data = {
      id: "TR-2024-0012",
      status: "Pending Approval",
      employee: "ALLISTAIR LORENZO JAMES",
      manager: "DYLAN REDAS NOEL",
      destination: "Houston, USA",
      period: "19 Apr 2023 - 01 May 2023",
      purpose: "Attend Simpleview Summit 2023",
      totalAdvance: "RM 8,970.00",
    };

    return (
      <div style={{ padding: 24 }}>

        {/* HEADER */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
          <div>
            <Link to="/travel" style={backLink}>← Back to Travel</Link>
            <h3 style={{ margin: "10px 0 4px" }}>{data.id}</h3>
            <div style={{ display: "flex", gap: 10 }}>
              {this.renderStatus(data.status)}
            </div>
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <button style={btnOutline}>Download PDF</button>
            <button style={btnOutline}>Return</button>
            <button style={btnDanger}>Reject</button>
            <button style={btnPrimary}>Approve</button>
          </div>
        </div>

        <div style={layout}>

          {/* LEFT */}
          <div>

            {this.renderSection(
              "Traveler Information",
              <div style={grid2}>
                {this.renderInfo("Employee", data.employee)}
                {this.renderInfo("Reporting Manager", data.manager)}
                {this.renderInfo("Destination", data.destination)}
                {this.renderInfo("Travel Period", data.period)}
                <div style={{ gridColumn: "1 / span 2" }}>
                  {this.renderInfo("Purpose", data.purpose)}
                </div>
              </div>
            )}

            {this.renderSection(
              "Schedule",
              <table style={table}>
                <thead>
                  <tr style={thead}>
                    <th style={th}>Date</th>
                    <th style={th}>Time</th>
                    <th style={th}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["19 Apr", "06:50", "Depart Kuching → KL"],
                    ["20 Apr", "10:25", "KL → Houston"],
                    ["23 Apr", "-", "Summit Day 1"],
                    ["24 Apr", "-", "Summit Day 2"],
                    ["26 Apr", "-", "Summit Day 4"],
                  ].map((r) => (
                    <tr key={r[0]} style={tr}>
                      <td style={td}>{r[0]}</td>
                      <td style={td}>{r[1]}</td>
                      <td style={td}>{r[2]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {this.renderSection(
              "Cash Advance",
              <div>
                <table style={table}>
                  <thead>
                    <tr style={thead}>
                      <th style={th}>Description</th>
                      <th style={{ ...th, textAlign: "right" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ["Meals", "RM 3,000"],
                      ["Transport", "RM 3,900"],
                      ["Misc", "RM 2,070"],
                    ].map((r) => (
                      <tr key={r[0]} style={tr}>
                        <td style={td}>{r[0]}</td>
                        <td style={{ ...td, textAlign: "right" }}>{r[1]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div style={total}>
                  <span>Total</span>
                  <span>{data.totalAdvance}</span>
                </div>
              </div>
            )}

            {this.renderSection(
              "Documents",
              <div>
                {[
                  "Event Invitation.pdf",
                  "Itinerary.pdf",
                  "Hotel Quotation.pdf",
                  "Passport.pdf",
                ].map((f) => (
                  <div key={f} style={fileRow}>
                    <span>{f}</span>
                    <button style={btnSmall}>View</button>
                  </div>
                ))}
              </div>
            )}

          </div>

          {/* RIGHT */}
          <div>

            <div style={card}>
              <h4 style={sectionTitle}>Summary</h4>
              {this.renderInfo("Destination", data.destination)}
              {this.renderInfo("Duration", "13 Days")}
              {this.renderInfo("Advance", data.totalAdvance)}
              <div style={statusBox}>Pending Approval</div>
            </div>

            <div style={card}>
              <h4 style={sectionTitle}>Approval Timeline</h4>

              {this.timeline("Submitted", "Staff submitted request", true)}
              {this.timeline("Manager Approval", "Pending", false)}
              {this.timeline("Admin Booking", "Waiting", false)}
              {this.timeline("Finance Payment", "Waiting", false)}
            </div>

          </div>

        </div>

      </div>
    );
  }

  timeline(title, desc, done) {
    return (
      <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
        <div style={{
          width: 22,
          height: 22,
          borderRadius: "50%",
          background: done ? "#1464E9" : "#E5E7EB",
        }} />
        <div>
          <div style={{ fontWeight: 700 }}>{title}</div>
          <div style={{ fontSize: 12, color: "#64748B" }}>{desc}</div>
        </div>
      </div>
    );
  }
}

/* STYLES */

const layout = {
  display: "grid",
  gridTemplateColumns: "2fr 1fr",
  gap: 20,
};

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 10,
  padding: 16,
  marginBottom: 16,
};

const sectionTitle = {
  marginBottom: 14,
  fontWeight: 900,
};

const grid2 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 12,
};

const infoLabel = {
  fontSize: 12,
  color: "#64748B",
};

const infoValue = {
  fontWeight: 700,
};

const table = {
  width: "100%",
  borderCollapse: "collapse",
};

const thead = {
  background: "#F8FAFC",
};

const th = {
  padding: 10,
  textAlign: "left",
  fontSize: 12,
};

const tr = {
  borderTop: "1px solid #E5E7EB",
};

const td = {
  padding: 10,
  fontSize: 13,
};

const total = {
  marginTop: 10,
  display: "flex",
  justifyContent: "space-between",
  fontWeight: 900,
};

const fileRow = {
  display: "flex",
  justifyContent: "space-between",
  padding: 10,
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  marginBottom: 8,
};

const btnPrimary = {
  background: "#1464E9",
  color: "#fff",
  border: 0,
  padding: "10px 14px",
  borderRadius: 6,
};

const btnDanger = {
  background: "#DC2626",
  color: "#fff",
  border: 0,
  padding: "10px 14px",
  borderRadius: 6,
};

const btnOutline = {
  border: "1px solid #CBD5E1",
  background: "#fff",
  padding: "10px 14px",
  borderRadius: 6,
};

const btnSmall = {
  ...btnOutline,
  padding: "6px 10px",
  fontSize: 12,
};

const backLink = {
  textDecoration: "none",
  fontSize: 13,
};

const statusBox = {
  background: "#FFF7E6",
  padding: 10,
  borderRadius: 6,
  textAlign: "center",
  fontWeight: 700,
};

export default TravelRequestDetail;